import { TextField as MuiTextField } from "@mui/material";
import { styled } from "styled-components";

export const StyledTextField = styled(MuiTextField)`
  & .MuiOutlinedInput-root {
    & fieldset {
      border-radius: 12px;
    }

    &:hover fieldset {
      border-color: rgb(121, 121, 121);
    }

    &.Mui-focused fieldset {
      border-width: 1px;
    }
  }

  & .MuiInputLabel-root {
    color: #a2a2a2;
  }
`;
